import { resolveMediaUrl } from './media';

export function extractListPayload(payload, key) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.[key])) {
    return payload[key];
  }

  return [];
}

export function normalizeProduct(product) {
  if (!product || typeof product !== 'object') {
    return product;
  }

  const images = Array.isArray(product.images)
    ? product.images.map(resolveMediaUrl).filter(Boolean)
    : [];
  const thumbnailImage = resolveMediaUrl(product.thumbnailImage || images[0] || '');

  return {
    ...product,
    images,
    thumbnailImage,
    glbModelUrl: resolveMediaUrl(product.glbModelUrl || ''),
  };
}

export function normalizeProducts(products) {
  return extractListPayload(products, 'products').map(normalizeProduct);
}
